import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
      setMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#080808]/95 backdrop-blur-md border-b border-[#C9A84C]/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <a href="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/26eb07eb1cfab8d1c82bf00206f32d1a/ce704c1a72b5bb712287fdfe1137d609.png"
            alt="EmCaLu AI Agency Logo"
            className="h-10 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: "About", id: "authority" },
            { label: "Process", id: "process" },
            { label: "Why Us", id: "differentiation" },
            { label: "Contact", id: "contact" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-light tracking-widest uppercase text-white/60 hover:text-[#C9A84C] transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <a
            href="https://calendly.com/alex-emcalu/30min"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-4 px-6 py-2.5 border border-[#C9A84C] text-[#C9A84C] text-sm font-medium tracking-widest uppercase hover:bg-[#C9A84C] hover:text-[#080808] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Strategy Call
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-8 h-8 flex flex-col items-center justify-center gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-px bg-white/80 transition-all duration-300 ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block w-6 h-px bg-white/80 transition-all duration-300 ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block w-6 h-px bg-white/80 transition-all duration-300 ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden bg-[#080808]/98 border-t border-[#C9A84C]/10 ${
          menuOpen ? "max-h-80 py-6" : "max-h-0"
        }`}
      >
        <div className="flex flex-col gap-4 px-6">
          {[
            { label: "About", id: "authority" },
            { label: "Process", id: "process" },
            { label: "Why Us", id: "differentiation" },
            { label: "Contact", id: "contact" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-light tracking-widest uppercase text-white/60 hover:text-[#C9A84C] transition-colors text-left cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("booking")}
            className="mt-2 px-6 py-3 border border-[#C9A84C] text-[#C9A84C] text-sm font-medium tracking-widest uppercase hover:bg-[#C9A84C] hover:text-[#080808] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Strategy Call
          </button>
        </div>
      </div>
    </nav>
  );
}
